export const CourseStatus = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
};
